import React, { useState } from 'react';
import { toast } from 'sonner';
import { Trash2, Plus, ShieldCheck } from 'lucide-react';
import { Panel, Empty, Badge } from '../../components/Primitives';
import { useFetch } from '../../lib/hooks';
import { api, errMsg, shortHash } from '../../lib/api';

export default function Wallet() {
  const { data: addrs, reload } = useFetch('/withdrawal-addresses');
  const [address, setAddress] = useState('');
  const [label, setLabel] = useState('');

  const add = async (e) => {
    e.preventDefault();
    if (!/^0x[a-fA-F0-9]{40}$/.test(address.trim())) return toast.error('Enter a valid BEP20 (0x…) address');
    try {
      await api.post('/withdrawal-addresses', { address: address.trim(), label });
      toast.success('Withdrawal address added'); setAddress(''); setLabel(''); reload();
    } catch (err) { toast.error(errMsg(err)); }
  };
  const remove = async (id) => {
    try { await api.delete(`/withdrawal-addresses/${id}`); toast.success('Address removed'); reload(); }
    catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div className="space-y-6" data-testid="wallet-page">
      <Panel title="Add Withdrawal Address (BEP20)">
        <form onSubmit={add} className="grid sm:grid-cols-3 gap-3">
          <input value={label} onChange={(e) => setLabel(e.target.value)} placeholder="Label (e.g. My Binance)" required className="h-11 px-3 rounded-lg bg-vj-charcoal border border-border text-sm text-foreground" data-testid="wallet-label-input" />
          <input value={address} onChange={(e) => setAddress(e.target.value)} placeholder="0x… BEP20 address" required className="h-11 px-3 rounded-lg bg-vj-charcoal border border-border font-mono text-sm text-foreground" data-testid="wallet-address-input" />
          <button className="h-11 rounded-lg bg-vj-neon text-vj-obsidian font-semibold text-sm inline-flex items-center justify-center gap-2 vj-glow-green hover:-translate-y-0.5 transition-all" data-testid="wallet-add-btn"><Plus size={16} /> Add Address</button>
        </form>
        <p className="text-[11px] text-vj-grey mt-3">Never share seed phrases or private keys. VEYJEX will never ask for them. Address changes may be subject to a security cooldown.</p>
      </Panel>

      <Panel title="Saved Addresses">
        {addrs && addrs.length ? (
          <div className="space-y-2">
            {addrs.map((a) => (
              <div key={a.id} className="flex items-center justify-between p-3 rounded-lg border border-border">
                <div>
                  <div className="text-sm font-medium flex items-center gap-2">{a.label} {a.verified && <Badge tone="green"><ShieldCheck size={11} /> Verified</Badge>}</div>
                  <div className="font-mono text-xs text-vj-grey">{shortHash(a.address)} · {a.network}</div>
                </div>
                <button onClick={() => remove(a.id)} className="text-vj-grey hover:text-vj-red" data-testid={`wallet-remove-${a.id}`}><Trash2 size={16} /></button>
              </div>
            ))}
          </div>
        ) : <Empty>No withdrawal addresses yet.</Empty>}
      </Panel>
    </div>
  );
}
